import { Outlet } from "react-router";
import HomeHeader from "../components/layouts/HomeHeader";

export default function HomeLayout() {
  return (
    <div className="w-full h-screen bg-gray-100 font-toyota">
      <HomeHeader />
      <Outlet />
    </div>
  );
}
